import React, { Suspense, useState, useRef, useEffect } from 'react';
import { saveResume, PREVIEW_RESUME, SAVE_RESUME, createNewResumewithData } from '../services/actions/actions';
import { Redirect, useHistory } from 'react-router';
import WpAPI from '../WpApi';
import { CREATE_RESUME, DASHBOARD_LINK, TPLS_COLOR, TPLTS, UPLOAD_RESUME, DEFAULT_VARIANT_COLOR,QUICK_EDITOR, COOKIE_DOMAIN, APP_DOMAIN, HEADING_LINK } from '../constants/constants';
import './../assets/scss/app/blocks/choose-template.scss';
import './../assets/scss/app/blocks/ai-resume.scss';
import Cookies from 'js-cookie';
import { validateEmail } from '../helper';
import axiosInstance, { handleRateLimitError } from '../services/axiosConfig';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import SignUpPopup from './user/SignUpPopup';
import { hasReachedResumeLimit, showResumeLimitAlert } from '../utils/resumeLimitCheck';
const CreateResumeWithAI = (props) => {
    // const statePreview = useSelector(state=>console.log("#####",state));
    const [redirectTo, setRedirectTo] = useState(false);
    const r_type = (new URLSearchParams(location.search)).get('u');
    const [step, setStep] = useState(1);
    const [chatGptError, setChatGptError] = useState(false);
    const [errorField, setErrorField] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({fname:'',lname:'', email:'', jobtitle:'', jobdescription:'', summary :'', ai_jobs : [], ai_skills : [], ai_accomplishments : [], ai_interests : []})
    const [showLoginPopUp, setShowLoginPopUp] = useState(false)
    const dispatch = useDispatch()
    //set dashboard_tab when ufirstomes from the main site or uses the direct URL
    const [isMounted, setIsMounted] = useState(true);
    const [chkPopupStatus, setChkPopupStatus] = useState(false);

    useEffect(() => {
        Cookies.set('dashboard_tab', 'resume', { domain: COOKIE_DOMAIN, path: "/" });

        // Check resume limit when accessing AI resume creation page
        if (hasReachedResumeLimit()) {
            showResumeLimitAlert('create');
            setRedirectTo(DASHBOARD_LINK);
        }

        return () => {
            setIsMounted(false);
        };

    }, []);
    
    useEffect(() => {
        //browser issue, page not opening at top
        window.scrollTo(0, 0)
    }, []);


    const validateForm = () => {
        let errors = {};
        // Check if email is empty or invalid
        if (!data.email.trim()) {
            errors.email = 'Email address is required';
        } else if (!validateEmail(data.email)) {
            errors.email = 'Invalid email address';
        }

        // Check if jobtitle is empty, contains spaces or dots, or is less than 3 characters
        if (step === 2) {
            if (!data.jobtitle.trim()) {
                errors.jobtitle = 'Job title is required';
            }else if (/^[\s.]/.test(data.jobtitle)) {
                errors.jobtitle = 'Job title cannot contain spaces or dots in begining';
            } else if (data.jobtitle.length < 2) {
                errors.jobtitle = 'Job title must be at least 2 characters';
            }
        }
        
        return errors; 
    };

    const generateContent = () => {
        let request = {
            action: 'generate_resume_content',
            job_title: data.jobtitle,
            job_descriptions : data.jobdescription
        }
        return new Promise((resolve, reject) => {
            axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(request))
                .then(response => {
                    if (response.data && response.data.status === 'ok') {
                        resolve(response.data); // Resolve with the data if status is ok
                    } else {
                        setChatGptError(true);
                        console.log('not ok');
                        reject('Response not ok');
                    }
                })
                .catch(error => {
                    setChatGptError(true);
                    console.error("Problem in generating content:", error);
                    
                    // Handle rate limiting specifically
                    const rateLimitInfo = handleRateLimitError(error, "AI service is temporarily busy. Please wait a moment and try again.");
                    if (rateLimitInfo.isRateLimited) {
                        // You can show a user-friendly message here
                        console.warn(rateLimitInfo.message);
                    }
                    
                    reject(error); // Reject with the error if something goes wrong
                });
        });
    }
    
    const submitRequest = () => {
        setIsLoading(true);
            generateContent()
            .then(res => {

                if (res?.status !== 'ok') {
                    console.error('Failed to generate content:', res);
                    return; // Early return if the response is not ok
                }                
                const newData = {
                    fname : data.fname,
                    lname: data.lname,
                    email : data.email,
                    jobtitle: data.jobtitle,
                    jobdescription : data.jobdescription,
                    summary: res.data.summary,
                    ai_jobs: res.data.job_descriptions,
                    ai_skills: res.data.skills,
                    ai_accomplishments: res.data.accomplishments,
                    ai_interests: res.data.interests
                };
                if (data?.jobtitle) {
                     dispatch(createNewResumewithData(newData, ()=>setRedirectTo(QUICK_EDITOR)));
                }
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            });
    }
    
     // Handle click of "Next" button
     const handleNextClick = () => {
        const validationErrors = validateForm(); 
        if (Object.keys(validationErrors).length > 0) {
            setErrorField(validationErrors);
            return;
        }
        setStep(2);
    };

    const handleJobTitleValidationONBlur = () => {
        let errors = {};
        if (!data.jobtitle.trim()) {
            errors.jobtitle = 'Job title is required';
        } else if (/^[\s.]/.test(data.jobtitle)) {
            errors.jobtitle = 'Job title cannot contain spaces or dots';
        } else if (data.jobtitle.length < 2) {
            errors.jobtitle = 'Job title must be at least 2 characters';
        }
        setErrorField(errors);
    };

    const handleGenerateClick = () => {
        const validationErrors = validateForm(); 
        if (Object.keys(validationErrors).length > 0) {
            setErrorField(validationErrors);
            return;
        }
        if (WpAPI.isLoggedIn()) {
            setStep(3);
            submitRequest();
        }else{
            setShowLoginPopUp(true);
            setChkPopupStatus(true);
        } 
    };
    useEffect(() => {
        if (WpAPI.isLoggedIn() && chkPopupStatus) {
            setStep(3);
            submitRequest();
            setChkPopupStatus(false);
        }
      }, [showLoginPopUp]);

    if (redirectTo) return <Redirect to={redirectTo} />
    return (<>
        {/* <Splash cssClass={'fullwidth mt'} /> */}
        <div className='ai-resume-container'>
        <div className={`template-selector-screen ai-resume-screen ${step === 3 ? 'loading' : ''}`} style={{height:"calc(100vh - 106px"}}>
            <div className="ai-resume-forms-container">
                   {step == 1 && 
                        <div className='ai-step-forms step-1'>
                            <div className='title'>
                                <span>Match Your Resume With AI</span>
                                <img src={`${APP_DOMAIN}/assets/images-new/icons/ai-resume-icon.svg`} />
                            </div>
                            <p>Please start by entering your personal information</p>
                            <div className='ai-form'>
                                <div className='input-field'>
                                    <span>
                                        <input placeholder='First Name' onChange={(e) => setData({...data, fname: e.target.value})} value={data.fname}/>
                                        {errorField.fname && <small className="error-text">{errorField.fname}</small>}
                                    </span>
                                    <span>
                                    <input placeholder='Last Name'  onChange={(e) => setData({...data, lname: e.target.value})} value={data.lname}/>
                                    {errorField.lname && <small className="error-text">{errorField.lname}</small>}
                                    </span>

                                </div>
                                <div className='input-field'>
                                    <span><input placeholder='Email Address' onChange={(e) => setData({...data, email: e.target.value})} value={data.email}
                                    onFocus={()=>setErrorField({...errorField, email:''})}
                                    onBlur={() => {
                                        if(data.email.trim() && !validateEmail(data.email)) setErrorField({email:'Invalid Email address'})
                                    }}/>
                                     {errorField?.email && <small className="error-text">{errorField.email}</small>}
                                     </span>
                                </div>
                                <div className='action-button'>
                                    {/* <button className='next' onClick={() => {
                                    if(errorField.email.trim()) setErrorField({email:'Please add Email address'})
                                    else if(!validateEmail(data.email)) setErrorField({email:'Invalid Email address'})
                                    else setStep(2)}
                                    }>Next</button> */}
                                    <button className="next" onClick={handleNextClick}>
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    }

                    {step == 2 &&
                        <div className='ai-step-forms step-2'>
                            <div className='title'>
                                <span>Match Your Resume With AI</span>
                                <img src={`${APP_DOMAIN}/assets/images-new/icons/ai-resume-icon.svg`} />
                            </div>
                            <p>Please start by entering your personal information</p>
                            <div className='ai-form'>
                                <div className='input-field'>
                                <span><input placeholder='Desired Job Position' onChange={(e) => setData({...data, jobtitle: e.target.value})} value={data.jobtitle}
                                        onFocus={()=>setErrorField({...errorField, jobtitle:''})}
                                        onBlur={handleJobTitleValidationONBlur}
                                    />
                                    {errorField?.jobtitle && <small className="error-text">{errorField.jobtitle}</small>}</span>
                                </div>
                                <div className='input-field'>
                                    <textarea placeholder='(Optional) Use the job description of the job you’re applying for to get personalized results' onChange={(e) => setData({...data, jobdescription: e.target.value})} value={data.jobdescription}></textarea>
                                </div>
                                <div className='action-button'>
                                    <button className='back'  onClick={() => setStep(1)}>Back</button>
                                    <button className='next'  
                                        onClick={() => {handleGenerateClick()}}
                                    >Generate</button>
                                </div>
                            </div>
                        </div>
                    }
                    {(step == 3 && !chatGptError) && 
                        <div  className='ai-step-forms step-3'>
                            <div className='title'>
                                <span>Generating</span>
                                <img src={`${APP_DOMAIN}/assets/images-new/icons/ai-resume-icon.svg`} />
                            </div>
                            
                            <p>Your resume will be created in a moment! </p>
                            {isLoading && (
                                    <div className="loader-container">
                                        <img
                                            className="ai-loader-img"
                                            src="/assets/images/ai-spinner.svg"
                                            alt="loader"
                                        />
                                    </div>
                            )}
                        </div>
                    }

                    {(step == 3 && chatGptError) && 
                        <div  className='ai-step-forms step-3'>
                            <div className='title'>
                                <span>Sorry!</span>
                            </div>
                            
                            <p>We ran into an issue. Please try again.</p>
                            <button className="try-btn" onClick={()=>{
                                setStep(2);
                                setChatGptError(false);
                            }}>Generate My Resume</button>
                        </div>
                    }

            </div>
        </div>
        </div>
        {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} setEntities={r => setEntities(r)} /> : ''}

</>);
}


export default CreateResumeWithAI;